<template>
    <vs-popup classContent="popup-example"  title="ویرایش محصول" :active.sync="showPopup">
        <div class="mb-base">
            <form class="px-4" @keydown.enter.prevent.self>
                <vs-row class="px-5 pb-5">
                    <vs-col vs-lg="5" vs-md="5" vs-sm="12">
                        <label class="vs-input--label">انتخاب کاربر</label>
                        <v-select :options="usersList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="user_id" :clearable="false" />
                    </vs-col>
                    <vs-col vs-lg="5" vs-md="5" vs-sm="12">
                        <label class="vs-input--label input-left">نوع دسته بندی</label>
                        <v-select :options="categoryList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="category" class="input-left" :clearable="false" />
                    </vs-col>
                    <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                        <label class="vs-input--label input-left">وضعیت</label>
                        <v-select :options="statusList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="status" class="input-left" :clearable="false" />
                    </vs-col>
                </vs-row>
                <div v-for="(item, index) in orders" :key="index" class="p-1 mt-4">
                    <span class="px-3">محصول شماره {{index+1}}</span>
                    <vs-button class="float-right btn-icon" color="danger" type="flat" @click="removeRow(index)" v-if="orders.length > 1">
                        حذف
                    </vs-button>
                    <vs-divider class="mb-5" />
                    <vs-row class="px-5 pb-5">
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label">عرض</label>
                            <vs-input class="w-9" v-model="item.width" @keydown.enter="editOrderInfo()" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label">ارتفاع</label>
                            <vs-input class="w-9" v-model="item.height" @keydown.enter="editOrderInfo()" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع سیستم</label>
                            <v-select :options="systemsList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.systemType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع اپراتور</label>
                            <v-select :options="operatorsList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.operatorType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label">نوع شیشه (سکوریت)</label>
                            <v-select :options="glassList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.glassType" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="4" vs-md="4" vs-sm="12">
                            <label class="vs-input--label input-left">نوع فریم</label>
                            <v-select :options="frameList.items" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.frameType" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label input-left">سندبلاست</label>
                            <v-select :options="sandblast" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="item.sandblast" class="input-left" :clearable="false" />
                        </vs-col>
                        <vs-col vs-lg="2" vs-md="2" vs-sm="12">
                            <label class="vs-input--label input-left">تعداد</label>
                            <vs-input-number min="1" :value="item.quantity" @input="updateItemQuantity($event, index)" class="item-center input-left" />
                        </vs-col>
                    </vs-row>
                </div>
                <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-col class="sm:w-1/2 w-full">
                        
                    </vs-col>
                    <vs-col class="sm:w-1/2 w-full">
                        <vs-button class="mr-3 float-right" @click="editOrderInfo()">ویرایش محصول</vs-button>
                        <vs-button class="mr-3 float-right" type="border" @click="addForm()">افزودن محصول</vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'EditOrderProduct',

    props: {
        popupEditOrder: {
            type: Boolean,
            default: false,
        },
        orderId: Number
    },
    
    components: {
        vSelect,
    },
    
    data() {
		return{
            showPopup: false,
			orders: [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            status: '',
            statusList: ['سفارش جدید','در حال بررسی','در انتظار تایید مشتری','تایید مشتری','مرحله اندازه گیری','مرحله تولید','مرحله ارسال','مرحله نصب','تکمیل شده','کنسل شده'],
            category: '',
            user_id: '',
            sandblast: [
                {
                    value: 'yes',
                    label: 'دارد'
                },
                {
                    value: 'no',
                    label: 'ندارد'
                }
            ],
		}
    },
    
    computed: {
		systemsList() {
            return {
                items: this.$store.state.orders.systems.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                        admin : `${robot.admin}`
                    }
                })
            }
    	},
        operatorsList() {
            return {
                items: this.$store.state.orders.operators.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} (${robot.price} ریال)`,
                    }
                })
            }
    	},
        glassList() {
      		return {
                items: this.$store.state.orders.glass.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
    	},
        frameList() {
      		return {
                items: this.$store.state.orders.frame.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
        },
        categoryList() {
      		return {
                items: this.$store.state.orders.category.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name}`,
                    }
                })
            }
        },
        usersList() {
            return {
                items: this.$store.state.users.users.map((robot) => {
                    return {
                        value: robot.id,
                        label : `${robot.name} ${robot.last_name}`,
                    }
                })
            }
		},
    },

    watch: { 
      	popupEditOrder: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.getUser()
                this.$store.dispatch('getSystemInfo').catch(() => {
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
                this.$store.dispatch('getOrderInfo', this.orderId)
                .then(res => {
                    this.$vs.loading.close()
                    let user = {
                        value: res.data.data.user_id.id,
                        label: res.data.data.user_id.name + ' ' + res.data.data.user_id.last_name
                    }
                    this.user_id = user
                    let cat = {
                        value: res.data.data.category.id,
                        label: res.data.data.category.name,
                        admin: res.data.data.category.admin
                    }
                    this.category = cat
                    this.status = res.data.data.status
                    this.orders = res.data.data.desc
                    this.orders.forEach(order => {
                        if(order.systemType != null){
                            order.systemType.label = order.systemType.name
                            order.systemType.value = order.systemType.id
                        }
                        if(order.operatorType != null){
                            order.operatorType.label = order.operatorType.name
                            order.operatorType.value = order.operatorType.id
                        }
                        if(order.glassType != null){
                            order.glassType.label = order.glassType.name
                            order.glassType.value = order.glassType.id
                        }
                        if(order.frameType != null){
                            order.frameType.label = order.frameType.name
                            order.frameType.value = order.frameType.id
                        }
                        if(order.sandblast == 'yes') {
                            order.sandblast = {}
                            order.sandblast.value = 'yes'
                            order.sandblast.label = 'دارد'
                        }
                        else {
                            order.sandblast = {}
                            order.sandblast.value = 'no'
                            order.sandblast.label = 'ندارد'
                        }

                        
                    })
                })
                .catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditOrder', newVal)
            this.orders = [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            this.category = ''
            this.user_id = ''
        },
    },

    created(){	
    },
    
    methods: {
        removeRow(i){
            if (i > -1) {
                this.orders.splice(i, 1);
            }
        },

        getUser(){
			this.$store.dispatch('getAllUsers').catch(() => {
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
		},
        
        updateItemQuantity(event, n) {
            this.orders[n].quantity = event
        },

        addForm() {
            let item = {
                width: '',
                height: '',
                quantity: 1,
                systemType: '',
                glassType: '',
                sandblast: '',
            }
            this.orders.push(item)
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        editOrderInfo(){
            this.$vs.loading()
            this.$emit('updatePopupEditOrder', false)
            let message = ''
            this.orders.forEach(order => {
                let width = '-'
                if(order.width != null){
                    width = order.width
                }
                let height = '-'
                if(order.height != null){
                    height = order.height
                }
                let type = 'نامشخص'
                if(order.systemType != null){
                    type = order.systemType.label
                }
                let operator = 'نامشخص'
                if(order.operatorType != null){
                    operator = order.operatorType.label
                }
                let glass = 'ندارد'
                if(order.glassType != null){
                    if(order.systemType.value != 11){
                        glass = order.glassType.label
                    }
                }
                let sandblast = 'ندارد'
                if(order.sandblast != null){
                    glass = order.sandblast.label
                }
                let frame = 'نامشخص'
                if(order.frameType != null){
                    frame = order.frameType.label
                }
                let text = `عرض: ${width} \nارتفاع: ${height} \n تعداد: ${order.quantity} \nنوع سیستم: ${type} \nنوع اپراتور: ${operator} \nنوع شیشه: ${glass} \n سندبلاست: ${sandblast} \nنوع فریم: ${frame}`
                message = message + text + '\n'
            });
            this.orders.forEach(order => {
                if(order.systemType !=null){
                    order.systemType = order.systemType.value
                }
                if(order.operatorType != null){
                    order.operatorType = order.operatorType.value
                }
                if(order.glassType != null){
                    order.glassType = order.glassType.value
                }
                if(order.frameType != null){
                    order.frameType = order.frameType.value
                }
                if(order.sandblast != null){
                    order.sandblast = order.sandblast.value
                }
                else {
                    order.sandblast = 'no'
                }
            });
            let payload = {
                orders: this.orders,
                category: {
                    id: parseInt(this.category.value),
                    name: this.category.label,
                    admin: parseInt(this.category.admin),
                },
                user_id: this.user_id.value,
                id: this.orderId,
                type: 'product',
                message: message,
                status: this.status
            }
            payload = { 
                data: JSON.stringify(payload),
            }
            
            this.orders = [
                {
                    width: '',
                    height: '',
                    quantity: 1,
                    systemType: '',
                    operatorType: '',
                    glassType: '',
                    frameType: '',
                    sandblast: ''
                },
            ],
            this.category = ''
            this.user_id = ''
			this.$store.dispatch('updateOrderInfo', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'سفارش با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            })
        },
    }
}
</script>